<div class="flex flex-col flex-grow">
  <mat-card class="flex">
    <mat-card-content class="!flex !flex-row !flex-nowrap py-2-important !items-center !w-full !justify-center" [style.border-bottom]="isEditMode ? '2px solid ' + cdwRedPrimary : 'none'">
      <cdw-ae-filter-bar
        *ngIf="!isEditMode"
        class="flex-1 min-w-0"
        [filterBarField]="filterBarSettings"
        [fieldMask$]="fieldMask$"
        [limitOneFilter$]="limitOneFilter$"
        [initialSelectedFilterFields$]="selectedFilterFields$"
        (filtersChange)="onFilterBarChange($event)"
      ></cdw-ae-filter-bar>
      <div class="flex gap-10">
        <!-- Revert Changes / Cancel Button (shown when in edit mode) -->
        <lib-cdw-button
          *ngIf="isEditMode"
          [level]="'secondary'"
          [fontColor]="grey400"
          [outlineColor]="grey400"
          fontWeight="700"
          (buttonClick)="revertChanges()"
          [disabled]="isSaving"
        >
          <div class="flex items-center gap-1">
            <span>{{ cellChanges.size === 0 ? 'Cancel' : 'Revert changes' }}</span>
          </div>
        </lib-cdw-button>
        
        <!-- Save Changes Button (shown when in edit mode) -->
        <lib-cdw-button
          *ngIf="isEditMode"
          [level]="'primary'"
          fontWeight="700"
          (buttonClick)="saveChanges()"
          [disabled]="isSaving || cellChanges.size === 0"
        >
          <div class="flex items-center gap-1">
            <span>{{ isSaving ? 'Saving...' : 'Save changes' }}</span>
          </div>
        </lib-cdw-button>
      </div>
    </mat-card-content>
  </mat-card>
  <lib-select-all-banner [fetchAllIds]="fetchAllIds"></lib-select-all-banner>
  <ag-grid-angular
    class="ag-theme-alpine mat-elevation-z8"
    style="height: 75%; width: 100%;"
    [gridOptions]="gridOptions"
    [defaultColDef]="defaultCdwColDef"
    [columnDefs]="columnDefs"
    [sideBar]="cdwSidebarDef"
    (rowClicked)="rowClickedHandler($event)"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
  <lib-grid-footer
    [selectedCount]="(selectedIdCount$ | async) || 0"
    [showSelectedCount]="showCheckboxSelection"
    [footerBgColor]="footerBgColor"
    [itemLabel]="itemLabel"
    [showingSelectedOnly]="showSelectedOnly"
    (clickShowSelectedOnly)="toggleShowSelectedOnly($event)"
    (clickDeselect)="handleDeselectAll()"
  ></lib-grid-footer>
</div>